import { render } from "./startTracking.vue?vue&type=template&id=24f6f2b1"
import script from "./startTracking.vue?vue&type=script&lang=js"
export * from "./startTracking.vue?vue&type=script&lang=js"

import "./startTracking.vue?vue&type=style&index=0&id=24f6f2b1&lang=css"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__